module.exports = __webpack_public_path__ + "cdd62942e145bf5b7b099d7fe4070f9a.png";